import ssa_111_1 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_1.pdf";
import ssa_111_2 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_2.pdf";
import ssa_111_3 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_3.pdf";
import ssa_111_4 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_4.pdf";
import ssa_111_5 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_5.pdf";
import ssa_111_6 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_6.pdf";
import ssa_111_7 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_7.pdf";
import ssa_111_8 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_8.pdf";
import ssa_111_9 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_9.pdf";
import ssa_111_10 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_10.pdf";
import ssa_111_11 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_11.pdf";
import ssa_111_12 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_12.pdf";
import ssa_111_13 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_13.pdf";
import ssa_111_14 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_14.pdf";
import ssa_111_15 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_15.pdf";
import ssa_111_16 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_16.pdf";
import ssa_111_17 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_17.pdf";
import ssa_111_18 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_18.pdf";
import ssa_111_19 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_19.pdf";
import ssa_111_20 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_20.pdf";
import ssa_111_21 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_21.pdf";
import ssa_111_22 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_22.pdf";
import ssa_111_23 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_23.pdf";
import ssa_111_24 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_24.pdf";
import ssa_111_25 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_25.pdf";
import ssa_111_26 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_26.pdf";
import ssa_111_27 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_27.pdf";
import ssa_111_28 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_28.pdf";
import ssa_111_29 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_29.pdf";
import ssa_111_30 from "@/assets/studentAwardsRouter/studentAwardsFile/111/ssa_111_30.pdf";

var awardsPath_111 = [
  ssa_111_1,
  ssa_111_2,
  ssa_111_3,
  ssa_111_4,
  ssa_111_5,
  ssa_111_6,
  ssa_111_7,
  ssa_111_8,
  ssa_111_9,
  ssa_111_10,
  ssa_111_11,
  ssa_111_12,
  ssa_111_13,
  ssa_111_14,
  ssa_111_15,
  ssa_111_16,
  ssa_111_17,
  ssa_111_18,
  ssa_111_19,
  ssa_111_20,
  ssa_111_21,
  ssa_111_22,
  ssa_111_23,
  ssa_111_24,
  ssa_111_25,
  ssa_111_26,
  ssa_111_27,
  ssa_111_28,
  ssa_111_29,
  ssa_111_30,
];
export { awardsPath_111 };
